import * as React from 'react';
import { useMemo } from 'react';
import isUrlHttp from 'is-url-http';

import { cn, listIconMap, itemListProps } from '@restworld/utils-common';

import { FontSize, TextColor, colorMap, sizeMap } from '../../';
import { Heading } from '@restworld/ui-ds-base';

export const SecondaryList: React.FunctionComponent<IListProps> = ({
  itemList,
  orientation = 'horizontal',
  fontSize,
  textColor,
  isWrapList = true,
}) => {
  const listElement = useMemo(() => getListElement({ fontSize, textColor, itemList }), [fontSize, itemList, textColor]);
  return (
    <Wrapper isWrapList={isWrapList} orientation={orientation}>
      {listElement}
    </Wrapper>
  );
};
export default SecondaryList;
// --> styled components
const Wrapper = ({ orientation, isWrapList, className, ...props }: any) => (
  <ul
    className={cn(
      'md:h-full md:max-h-[15rem]',
      orientation === 'vertical' ? 'flex flex-col gap-x-2' : 'flex gap-x-3 justify-center self-center',
      isWrapList ? (orientation === 'vertical' ? 'flex-wrap' : 'flex-wrap-reverse') : '',
      className
    )}
    {...props}
  />
);
const getListElement = ({ itemList, fontSize, textColor }: listElementType) =>
  itemList?.map(({ label, icon, key }) => {
    const iconEl = icon
      ? Object.keys(listIconMap).includes(icon)
        ? listIconMap[icon]
        : isUrlHttp(icon) && <Image src={icon} alt="" />
      : '';
    return (
      <ListWrapper key={key} fontSize={fontSize} textColor={textColor}>
        {iconEl ? <Icon>{iconEl}</Icon> : ''}
        <Heading as="span" size={5} weight="normal" className="font-light">
          {label}
        </Heading>
      </ListWrapper>
    );
  });
const ListWrapper = ({ textColor, fontSize, className, ...props }: any) => (
  <li
    className={cn(
      'flex flex-row gap-1 pb-2 items-center font-normal',
      colorMap[textColor],
      sizeMap[fontSize],
      className
    )}
    {...props}
  />
);
const Icon = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => (
  <div className={cn('shrink-0', className)} {...props} />
);
const Image = ({ className, ...props }: React.ImgHTMLAttributes<HTMLImageElement>) => (
  <img className={cn('h-5 w-5', className)} {...props} />
);
// --> types
export type orientationType = 'horizontal' | 'vertical';
type listElementType = {
  itemList: itemListProps[];
  fontSize?: FontSize;
  textColor?: TextColor;
};
interface IListProps extends listElementType {
  orientation?: orientationType;
  isWrapList?: boolean;
}
